import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const transFormModalData = dropDownKeys => {
  const transformedData = {};
  Object.keys(dropDownKeys).forEach(key => {
    const model = dropDownKeys[key] || {};
    transformedData[key] = model.value || null;
    transformedData[`${key}Label`] = model.label || "";
  });

  return transformedData;
};

export const defaultDropdownConfig = {
  pageIndex: 1,
  pageSize: 100,
  orderByAscending: true,
  searchString: ""
};

export const paginatedDropdownConfig = {
  pageSize: 300,
  orderByAscending: true,
  searchString: "",
};

export const employmentStatusOptions = [
  {
    label: "New Employee",
    value: "New"
  },
  {
    label: "Current Employee",
    value: "Current"
  }
];

export const sexOptions = [
  {
    label: "Male",
    value: "male"
  },
  {
    label: "Female",
    value: "female"
  },
  {
    label: "Participant Did Not Self Identify",
    value: "notIdentify"
  }
];

export const payrollTypeOptions = [
  { label: "Weekly", value: "1" },
  { label: "BiWeekly", value: "2" },
  { label: "Monthly", value: "3" }
];

export const timekeepingOptions = [
  { label: "Daily", value: "1" },
  { label: "Weekly", value: "2" }
];

export const correctionReviewOptions = [
  { label: "Approved", value: "1" },
  { label: "Denied", value: "2" }
];

export const correctionDocumnetOptions = [
  { label: "Check Stub", value: "1" },
  { label: "Cancelled Check", value: "2" },
  { label: "ACH Confirmation", value: "3" },
];

export const CourseContentDeliveryOptions = [
  { label: "Fixed Schedule", value: "1" },
  { label: "Flexible", value: "2" },
  { label: "Adaptive RTI", value: "3" },
  { label: "Accelerated Path", value: "4" },
  { label: "ALL", value: "5" }
];

export const TrackingMethod = [
  { label: "ProScore Mobile App", value: "1" },
  { label: "Client Timekeeping System", value: "2" },
  { label: "Manual Timesheet", value: "3" }
];
export const ElearningHoursPaidOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const RelatedInstructionIsProvidedOptions = [
  { label: "During Work Hours", value: "DuringWorkHours" },
  { label: "Not During Work Hours", value: "NotDuringWorkHours" },
  {
    label: "Both During and Not During Work Hours",
    value: "BothDuringandNotDuringWorkHours"
  }
];
export const yesNoOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export const weekdaysOptions = [
  { id: "Sun", label: "Sun" },
  { id: "Mon", label: "Mon" },
  { id: "Tue", label: "Tue" },
  { id: "Wed", label: "Wed" },
  { id: "Thu", label: "Thu" },
  { id: "Fri", label: "Fri" },
  { id: "Sat", label: "Sat" }
];

export const fringePayModeOptions = [
  { id: "cash", label: "Cash" },
  { id: "benefits", label: "Benefits" },
  { id: "both", label: "Cash & Benefits" },
];

export const isAmendedCprOptions = [
  {
    label: (
      <>
        Full Report
      </>
    ),
    value: false,
    id: "false",
  },
  {
    label: (
      <>
        Only Amended Records
        <Tooltip
          title="Only the amended records (such as hours, rates, or fringe data; backpay/interest) will be highlighted in CPR."
          arrow
        >
          <IconButton size="small" sx={{ ml: 0.5 }}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </>
    ),
    value: true,
    id: "true",
  },
];

export const isSupplementCprOptions = [
  {
    label: (
      <>
        Full Report
      </>
    ),
    value: false,
    id: "false",
  },
  {
    label: (
      <>
        Only Changed Records
        <Tooltip
          title="Only the changed records (adding additional hours/dollars) will be highlighted in CPR."
          arrow
        >
          <IconButton size="small" sx={{ ml: 0.5 }}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </>
    ),
    value: true,
    id: "true",
  },
];

export const ContractorOptions = [
  { id: "Prime Contractor", label: "Prime Contractor" },
  { id: "Subcontractor", label: "Subcontractor" },
];

export const CPRVersionDropDown = [
  { label: "Version Expiring 9/30/2026", value: "Version Expiring 9/30/2026" },
  { label: "Version Expiring 1/31/2028", value: "Version Expiring 1/31/2028" }
];

export const timeKeeping = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const communitySolarOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const coLocatedProjectOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const projectKickoff = [
  { label: "Fall", value: "Fall" },
  { label: "Winter", value: "Winter" },
  { label: "Spring", value: "Spring" },
  { label: "Summer", value: "Summer" }
];
export const documentType = [
  { label: "Davis Bacon Forms", value: "Davis Bacon Forms" },
  { label: "Journey Worker Certifications", value: "Journey Worker Certifications" },
  { label: "Apprenticeship Standards", value: "Apprenticeship Standards" },
  { label: "Proof of Reciprocity", value: "Proof of Reciprocity" },
  { label: "Good Faith Effort Documentation", value: "Good Faith Effort Documentation" },
  { label: "Apprentice Good Standing Letter", value: "Apprentice Good Standing Letter" },
  { label: "History of Underpayment", value: "History of Underpayment" },
  { label: "Proof of Payroll Correction", value: "Proof of Payroll Correction" },
  { label: "Proof of Fines Paid", value: "Proof of Fines Paid" }
];
export const interconnectionApproval = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Pending", value: "Pending" }
];

export const payTypePositionOption = [
  { label: "Hourly", value: "Hourly" },
  { label: "Salary", value: "Salary" }
];
export const operator = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const typeOfOperatorOption = [
  { label: "Heavy Equipment Operator", value: "heavy equipment operator" },
  { label: "Light Equipment Operator", value: "light equipment operator" },
  { label: "Line Operator", value: "line operator" },
  { label: "Power Equipment Operator", value: "power equipment operator" }
];
export const jobCategories = [
  { label: "General Labor", value: "general labor" },
  { label: "Construction Labor", value: "construction labor" }
];
export const responsibleForUpkeep = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export const employeeTypeOptions = [
  { label: "Apprentice", value: 1 },
  { label: "Mentor", value: 2 },
  { label: "Journeyman", value: 3 },
  { label: "Apprentice Prospect", value: 4 },
  { label: "Journey Worker Helper", value: 5 },
  { label: "Admin", value: 6 }
];

export const apprenticeProspectStatusOptions = [
  { label: "Application Sent", value: 1 },
  { label: "Application Received", value: 2 },
  { label: "Additional Documents Requested", value: 3 },
  { label: "Additional Documents Received", value: 4 },
  { label: "Evaluation Sent", value: 5 },
  { label: "Evaluation Received", value: 6 },
  { label: "Interview Scheduled", value: 7 },
  { label: "Interview Complete", value: 8 },
  { label: "Approved", value: 9 },
  { label: "Rejected", value: 10 },
  { label: "Pipelined", value: 11 }
];
